const initialState = {
  schoolList: [],
  instituteList: [],
  validate: false,
  serverErrors: {},
  isValidated: true,
  afterValidate: false,
  successRegister: false,
  successRestore: false,
  successSaveRestore: false,
  successMessage: '',
  failMessage: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SCHOOL_LIST':
      return {...state, schoolList: action.schoolList};
    case 'INSTITUTE_LIST':
      return {...state, instituteList: action.instituteList};
    case 'RESET_VALIDATION':
      return {
        ...state,
        validate: false,
        afterValidate: false,
        successMessage: '',
        failMessage: '',
        successRegister: false,
        successAuth: false,
        successRestore: false,
        successSaveRestore: false,
      };
    case 'FORM_SUBMIT':
      return {...state, validate: true, isValidated: true};
    case 'AFTER_VALIDATE':
      return {...state, afterValidate: true};
    case 'VALIDATION_FAILED':
      return {...state, isValidated: false};
    case 'ERRORS_FROM_SERVER':
      return {...state, serverErrors: action.errors, validate: true};
    case 'FIX_SERVER_ERROR':
      return {...state, serverErrors: action.serverErrors};
    case 'REGISTRATION_SUCCESS':
      return {
        ...state,
        successMessage: action.successMessage,
        failMessage: '',
        validate: false,
        afterValidate: false,
        successRegister: true
      };
    case 'AUTH_SUCCESS':
      return {
        ...state,
        validate: false,
        afterValidate: false
      };
    case 'AUTH_FAIL':
      return {
        ...state,
        successMessage: '',
        failMessage: action.failMessage
      };
    case 'RESTORE_SUCCESS':
      return {
        ...state,
        successMessage: action.successMessage,
        failMessage: '',
        validate: false,
        afterValidate: false,
        successRestore: true
      };
    case 'RESTORE_SAVE_SUCCESS':
      return {
        ...state,
        successMessage: action.successMessage,
        failMessage: '',
        validate: false,
        afterValidate: false,
        successSaveRestore: true
      };
    case 'RESTORE_SAVE_FAIL':
      return {
        ...state,
        failMessage: action.message,
        successMessage: ''
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth-reducer.js